module.exports = __webpack_public_path__ + "static/media/select-meta.c944b5d2.svg";